import { Media } from './Media';
import { FragmentMeta } from '../content/model/FragmentMeta';
import { ImageUrlBuilder } from './ImageUrlBuilder';
import { VideoMeta } from './MediaMeta';
/**
 * Class representing a Video resource with helper functions.s
 */
export class Video extends Media {
    /**
     * Creates a new Video instance.
     * @param data JSON data from delivery API
     */
    constructor(data, config) {
        super(data, config);
        if (data && data._meta) {
            this._meta = new VideoMeta(data._meta);
        }
    }
    /**
     * Returns a builder which can be used to construct a video thumbnail URL.
     * You can apply transformations such as resize and image format using the returned builder.
     *
     * ```typescript
     * video.thumbnail().width(500).build();
     * ```
     */
    thumbnail() {
        return new ImageUrlBuilder(this);
    }
    /**
     * Export Video to JSON
     */
    toJSON() {
        const result = super.toJSON();
        if (this._meta) {
            result._meta = this._meta.toJSON();
        }
        return result;
    }
    /**
     * @hidden
     * Returns true if the provided fragment is a video
     * @param fragment
     */
    static isVideo(fragment) {
        return (FragmentMeta.isFragment(fragment) &&
            fragment._meta.schema ===
                'http://bigcontent.io/cms/schema/v1/core#/definitions/video-link');
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmlkZW8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21lZGlhL1ZpZGVvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFDaEMsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLCtCQUErQixDQUFDO0FBQzdELE9BQU8sRUFBRSxlQUFlLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUVwRCxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBRXhDOztHQUVHO0FBQ0gsTUFBTSxPQUFPLEtBQU0sU0FBUSxLQUFLO0lBTTlCOzs7T0FHRztJQUNILFlBQVksSUFBUyxFQUFFLE1BQTJCO1FBQ2hELEtBQUssQ0FBQyxJQUFJLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFDcEIsSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLEtBQUssRUFBRTtZQUN0QixJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksU0FBUyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztTQUN4QztJQUNILENBQUM7SUFFRDs7Ozs7OztPQU9HO0lBQ0gsU0FBUztRQUNQLE9BQU8sSUFBSSxlQUFlLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDbkMsQ0FBQztJQUVEOztPQUVHO0lBQ0gsTUFBTTtRQUNKLE1BQU0sTUFBTSxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUM5QixJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDZCxNQUFNLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUM7U0FDcEM7UUFDRCxPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxPQUFPLENBQUMsUUFBYTtRQUNqQyxPQUFPLENBQ0wsWUFBWSxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUM7WUFDakMsUUFBUSxDQUFDLEtBQUssQ0FBQyxNQUFNO2dCQUNuQixpRUFBaUUsQ0FDcEUsQ0FBQztJQUNKLENBQUM7Q0FDRiJ9